//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum TypeOfMassive {
	SalesPerson = 0,
	Refer = 1,
	Signaler = 2,
	Manager = 3,
	Reports = 4,
	QuoteStage = 5,
	Sync = 6,
	DND = 7,
	Group = 8,
	Merge = 9,
	MLFlag = 10,
	Category = 11,
	Owner = 12,
	OpenTicket = 13,
	CommercialZone = 14,
	LeadStatus = 15,
	LeadRating = 16,
	LeadProductInterest = 17,
	ConvertLeadToCompany = 18,
	ActivityStatus = 19,
	ActivityInOut = 20,
	ActivityClassification = 21,
	ActivityToBill = 22,
	ActivityCommercial = 23,
	ActivityTechnical = 24,
	RecalcCost = 25,
	TicketWorkGroup = 26,
	TicketArea = 27,
	TicketType = 28,
	TicketAssignedTo = 29,
	TicketPriority = 30,
	TicketStatus = 31,
	FreeFields = 32,
	Country = 33,
	Workgroup = 34,
	Source = 35,
	Rating = 36,
	Payment = 37,
	PaymentMode = 38,
	PriceList = 39,
	CompanyType = 40,
	CompanySect = 41,
	IsPaid = 42,
	Appearance = 43,
	Porto = 44,
	Carrier = 45,
	OrderStage = 46,
	ShippedBy = 47,
	Currency = 48,
	LeadArea = 49,
	LeadPriority = 50,
	JobOrderTaskStatus = 51,
	JobOrderTaskType = 52,
	JobOrderTaskWorkGroup = 53,
	JobOrderTaskOwnerId = 54,
	OpportunityStatus = 55,
	OpportunityCategory = 56,
	OpportunityPhase = 57,
	OpportunityAmount = 58,
	OpportunityBudget = 59,
	OpportunityProbability = 60,
	OpportunityOwner = 61,
	OpportunitySalesPerson = 62,
	OpportunityCloseDate = 63,
	OpportunityLostReason = 64,
	ContractTypeOfServiceCatalogId = 65,
	ContractTypeOfServiceDescription = 66,
	ContractTypeOfServiceQty = 67,
	ContractTypeOfServiceFirstactivation = 68,
	ContractTypeOfServiceTermination = 69,
	ContractTypeOfServiceStartDate = 70,
	ContractTypeOfServiceEndDate = 71,
	ContractTypeOfServiceCancellation = 72,
	ContractTypeOfServiceCrossCompanyId = 73,
	ContractTypeOfServiceRenew = 74,
	ContractTypeOfServiceRenewMonth = 75,
	ContractTypeOfServiceContractDaysCancellation = 76,
	ContractTypeOfServiceTypeValue = 77,
	ContractTypeOfServiceTypeOfInstalmentValue = 78,
	ContractTypeOfServiceSubscriptionPriceValue = 79,
	ContractTypeOfServiceTaxCodeValue = 80,
	ContractTypeOfServiceStatusValue = 81,
	Privacy = 82,
	Tags = 83,
	BusinessRole = 84,
	RollingStockProductId = 85,
	RollingStockCompanyId = 86,
	RollingStockActive = 87,
	RollingStockMachineType = 88,
	RollingStockMountedOn = 89,
	RollingStockNote = 90,
	RollingStockManufacturerId = 91,
	CatalogTaxCode = 92,
	CatalogPrintDescription = 93,
	CatalogPriceExpire = 94,
	CatalogLifeMonth = 95,
	CatalogSeller = 96,
	CatalogRenewable = 97,
	CatalogPublish = 98,
	CatalogActive = 99,
	CatalogCategory = 100,
	CatalogMaxDiscount = 101
}
